// Module-level holder for the current access token. React components (inside the
// AuthProvider) push the token in via setAccessToken; the axios interceptor — which
// runs outside React and can't use hooks — reads it via getAccessToken.
let accessToken: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}
